<template>
   <section class="categoryheading">
      <div class="container">
         <div class="categoryheading__title">
            <h2>{{ category.title }}</h2>
            <span>{{ category.linkSubTitle }}</span>
            <div class="categoryheading__video" v-if="category.categoryVideo" @click="changeVideoActive">
               <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
                  <path d="M437.02,74.98C388.667,26.628,324.38,0,256,0S123.333,26.628,74.98,74.98C26.628,123.333,0,187.62,0,256 s26.628,132.667,74.98,181.02C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.98 C485.372,388.667,512,324.38,512,256S485.372,123.333,437.02,74.98z M256,491.602c-129.911,0-235.602-105.69-235.602-235.602 S126.089,20.398,256,20.398S491.602,126.089,491.602,256S385.911,491.602,256,491.602z" />
                  <path d="M370.635,228.558L224.051,129.43c-10.178-6.882-23.241-7.577-34.092-1.818c-10.852,5.762-17.593,16.974-17.593,29.259 v198.256c0,12.286,6.741,23.497,17.593,29.258c4.887,2.595,10.222,3.88,15.54,3.88c6.491,0,12.957-1.914,18.551-5.698l146.584-99.128c9.123-6.169,14.57-16.428,14.57-27.441C385.205,244.986,379.758,234.728,370.635,228.558z M359.207,266.542 L212.623,365.67c-3.969,2.684-8.865,2.947-13.099,0.699c-4.232-2.247-6.759-6.449-6.759-11.242V156.871 c0-4.792,2.526-8.995,6.759-11.242c1.911-1.014,3.957-1.518,5.992-1.518c2.473,0,4.929,0.744,7.108,2.216l146.583,99.126 c3.559,2.406,5.598,6.249,5.598,10.544C364.805,260.293,362.764,264.136,359.207,266.542z"/>
                  <path d="M450.365,178.795C428.7,124.297,384.824,81.139,329.987,60.387c-5.269-1.994-11.155,0.661-13.149,5.929 c-1.995,5.268,0.66,11.155,5.929,13.149c49.49,18.728,89.089,57.68,108.643,106.866c1.589,3.998,5.424,6.434,9.48,6.434 c1.253,0,2.528-0.234,3.766-0.724C449.89,189.96,452.447,184.029,450.365,178.795z"/>
                  <path d="M291.371,49.898c-11.604-1.979-23.504-2.981-35.371-2.981c-5.633,0-10.199,4.566-10.199,10.199S250.367,67.315,256,67.315 c10.721,0,21.468,0.906,31.943,2.691c0.579,0.099,1.157,0.147,1.726,0.147c4.88,0,9.195-3.514,10.042-8.486 C300.657,56.113,296.923,50.844,291.371,49.898z"/>
               </svg>
               <sub>Tap to play video</sub>
            </div>
         </div>
      </div>
      
      <div class="categoryheading__img" v-bind:style="{ background: 'url(' + category.categoryHeadImage + ')' + 'no-repeat center center' }"></div>
      <div class="categoryheading__content">
         <p>{{ category.linkInfo }}</p>
      </div>
   </section>

</template>

<script>

   export default {
      name: 'categoryHeading',
      props: ['category'],

      methods: {
         changeVideoActive: function(){
            this.$emit('is-video-active')
         }
      },

   }
</script>
